import React from 'react';
import PropTypes from 'prop-types';

import api from '../../../../../apiSingleton';
import ContactsHidden from './ContactsHidden';
import { Contacts as ContactsButton } from '../../../../Buttons';
import { PAGE_TYPES } from '../../../../../consts';

class Contacts extends React.Component {
  constructor (props) {
    super(props);

    this.item = props.item;
    this.rawItem = props.rawItem;
    this.author = this.item.getAuthor();
    this.agency = this.author.getAgency();
    this.contact = this.item.getContact();
    this.phones = this.contact.getPhones()
        .map((c, i) => {
          return (
            <div className='item-contact' key={i}>
              <span className='icon-phone' />
              <span className='content'>{c}</span>
            </div>
          );
        });

    this.state = {
      show: props.user.getIn(['data', 'isRealtor'], false) || false,
      showMore: this.phones.length <= 2
    };

    this.showContacts = this.showContacts.bind(this);
    this.handlerShowMore = this.handlerShowMore.bind(this);
  }

  hitContacts () {
    this.props.eventShowContacts(this.rawItem);

    api.announcement
        .hitContacts(this.item.getDealType(), this.item.getRealtyType(), this.item.getProperty().getId(), PAGE_TYPES.TYPE_LISTING)
        .catch(x => null);
  }

  showContacts () {
    this.setState({
      show: true,
      showMore: true
    });

    this.hitContacts();
  }

  handlerShowMore (e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({
      showMore: true
    });

    this.hitContacts();
  }

  renderPhones () {
    const {showMore} = this.state;

    if (showMore) {
      return (<div className='main-param'>{this.phones}</div>);
    }

    return (
      <div className='main-param'>
        {this.phones.slice(0, 2)}
        <a className='btn-show-more' onClick={this.handlerShowMore} href='#'>еще телефоны</a>
      </div>
    );
  }

  render () {
    // TODO: узнать что такое complaintLink() в аренде (связано с МЛС)

    if (!this.author.isExist()) {
      return (
        <ContactsHidden item={this.item} />
      );
    }

    const trusted = this.item.getAuthor().isTrusted();
    const name = this.contact.getName();

    return (
      <td className='col-contacts'>
        {
          this.state.show
          ? (this.renderPhones())
          : <ContactsButton onClick={this.showContacts} value={this.contact.getPhones()[0]} />
        }

        {name && <div className='author'>{name}</div>}

        {this.agency && (
          <div
            className='only-user btn-underline-secondary'
            data-tip={'Объявления от ' + this.agency.getName()}
            onClick={() => this.props.onUpdateFilter({onlyOwners: null, agencyId: this.agency.getId()})}>
              {this.agency.getType() + ' ' + this.agency.getName()}
          </div>)
        }
        {this.author.isOwner() && (
          <div
            className='only-user btn-underline-secondary'
            data-tip='Объявления от собственников'
            onClick={() => this.props.onUpdateFilter({onlyOwners: 1, agencyId: null})}>
            СОБСТВЕННИК
          </div>)
        }

        { trusted && <div data-tip data-for='tip-trusted' className='vas-trusted'>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'>
            <path fill='#749B0A' fillRule='nonzero' d='M11.235 2.158L4.624 5.01A1.84 1.84 0 0 0 3.5 6.688v4.31C3.5 16.085 7.127 20.844 12 22c4.873-1.155 8.5-5.914 8.5-11.003v-4.31a1.84 1.84 0 0 0-1.124-1.677l-6.611-2.852a1.93 1.93 0 0 0-1.53 0zm-1.794 13.69l-2.447-2.375a.894.894 0 0 1 0-1.293.96.96 0 0 1 1.332 0l1.785 1.724 5.553-5.392a.96.96 0 0 1 1.332 0 .894.894 0 0 1 0 1.293l-6.224 6.043a.96.96 0 0 1-1.331 0z' />
          </svg>
          <span>
            МОЖНО ДОВЕРЯТЬ
          </span>
        </div> }
      </td>
    );
  }
}

Contacts.propTypes = {
  item: PropTypes.object.isRequired,
  rawItem: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  onUpdateFilter: PropTypes.func.isRequired,

  eventShowContacts: PropTypes.func
};

Contacts.defaultProps = {
  eventShowContacts: () => {}
};

export default Contacts;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/GridCells/Contacts.jsx